import React, { Component } from "react";
import commStyles from "../../../common/styles";
import { connect } from "react-redux";
import {activeUser} from "../../../common/redux/actions";


const {
  ModelBoxWrapper,
  ModelContainer,
  ModelTitleWrapper,
  MainModelContainer,
  Title,
  ModelContentWrapper,
  FormColumn,
} = commStyles;

class Model extends Component {
  state = {};

  render() {
    return (
      <React.Fragment>
        <MainModelContainer
          style={
            this.props.modelOpen
              ? { display: "flex" }
              : { display: "none" }
          }
        >
          <ModelContainer style={{maxWidth : this.props.maxWidth, maxHeight : this.props.maxHeight}}>
            <ModelBoxWrapper>
              <ModelTitleWrapper>
                <Title>{this.props.title}</Title>
              </ModelTitleWrapper>
              <ModelContentWrapper>
                <FormColumn>
                  {this.props.children}
                </FormColumn>
              </ModelContentWrapper>
            </ModelBoxWrapper>
          </ModelContainer>
        </MainModelContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return { state };
};

export default connect(
  mapStateToProps,
  {activeUser})(Model);
